
export default {
  methods: {
    __(key) {
      return this.$store.getters['translate'](key) ?? key
    },
  },
}
